import { useEffect, useState } from "react";
import classes from "./UserAccount.module.css";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SearchIcon from "@mui/icons-material/Search";
import HouseIcon from "@mui/icons-material/House";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate, useLocation } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import { SELF_IMAGE } from "../../navigation/CONSTANTS";
import { CustomButton } from "../../components/RosterConfig/RosterConfigStyle";
import { Menu, MenuItem, Typography } from "@mui/material";
import { useAuth as useOidcAuth } from "react-oidc-context";

const UserAccount = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const location = window.location.pathname.split("/");
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [userInitials, SetUserInitials] = useState("");
  const { signoutRedirect } = useOidcAuth();

  const locationObj = useLocation();
  const [avatarKey, setAvatarKey] = useState(0);

  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      setAvatarKey((prev) => prev + 1);
      count += 1;
      if (count >= 3) {
        clearInterval(interval);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [locationObj.pathname]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutHandler = async () => {
    // Preserve user preference across logout
    const doNotShowReleaseNotesAgain = localStorage.getItem(
      "doNotShowReleaseNotesAgain",
    );

    // Clear app localStorage
    localStorage.clear();
    localStorage.setItem(
      "doNotShowReleaseNotesAgain",
      doNotShowReleaseNotesAgain,
    );

    // Clear sessionStorage (where oidc-client-ts stores its cache)
    sessionStorage.clear();

    // DELIBERATE BEHAVIOR CHANGE from the old MSAL logout: the previous
    // logoutRedirect() call suppressed the actual Azure AD logout redirect
    // (onRedirectNavigate: () => false) and only cleared MSAL's local
    // cache — it never actually ended the Azure AD session server-side.
    // This redirects through PingOne's real end-session endpoint and back,
    // which is what actually clears the PingOne-side session (not just
    // this tab's copy of the token) — the clean-logout behavior called out
    // as a first-class requirement for this migration. The page navigates
    // away here, so there's no follow-up window.location.href like before.
    await signoutRedirect({
      post_logout_redirect_uri: `${window.location.origin}/`,
    });
  };

  const handleImageError = () => {
    setIsError(true);
    const userName = localStorage.getItem("User");
    if (userName) {
      const nameSplit = userName.trim().split(/\s+/);
      if (nameSplit.length >= 2) {
        SetUserInitials(
          (nameSplit[0][0] + nameSplit[nameSplit.length - 1][0]).toUpperCase(),
        );
      }
    }
  };

  return (
    <>
      {isError ? (
        <Avatar onClick={handleMenu} className={classes.initialsAvatar}>
          {userInitials}
        </Avatar>
      ) : (
        <Avatar
          key={avatarKey}
          alt="User Avatar"
          src={SELF_IMAGE + localStorage.getItem("EmailId")}
          onClick={handleMenu}
          className={classes.accountCircleIcon}
          onError={handleImageError}
        />
      )}

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <div className={classes.logoutContainer}>
          <Typography component="h1" variant="h6" className={classes.name}>
            {localStorage.getItem("User")}
          </Typography>
        </div>
        <hr />
        <MenuItem className={classes.menuItem}>
          <HouseIcon
            className={classes.activeIcons}
            onClick={(e) => {
              navigate("/welcome");
              handleClose();
            }}
          />
          <NotificationsIcon disabled className={classes.icons} />
          <SearchIcon disabled className={classes.icons} />
          <SettingsIcon disabled className={classes.icons} />
        </MenuItem>
        <MenuItem>
          <CustomButton
            variant="contained"
            className={classes.logout}
            onClick={logoutHandler}
          >
            Logout
          </CustomButton>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserAccount;
